import styles from "./Us30Page.module.css";
import us30BannerImage from "../../assets/images/us30-banner.png";
import founderImage from "../../assets/images/admin.jpg";
import videoPlaceholderImage from "../../assets/images/video-player-placeholder.png";
import api from "../../services/api";
import { ENDPOINTS } from "../../utils/endpoints";
import { useState, useEffect, useRef } from "react";
import useDashboardStore from "../../store/dashboardStore";

const Us30Page = () => {
  const { setIsZoomMeetingScreen, setSelectedZoomSession } =
    useDashboardStore();
  const scrollRef = useRef(null);
  const [us30, setUs30] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -600, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 600, behavior: "smooth" });
  };

  useEffect(() => {
    const fetchUS30Data = async () => {
      try {
        const { data } = await api.get(ENDPOINTS.GET_US30_LIVE_SESSION);
        if (data.success) {
          setUs30(data.session);
        }
      } catch (err) {
        console.error("Failed to fetch us30 data", err);
      }
    };

    fetchUS30Data();
  }, []);

  useEffect(() => {
    if (!us30?.start_datetime) return;
    const calculateTimeLeft = () => {
      if (us30) {
        const difference = new Date(us30.start_datetime) - new Date();
        if (difference <= 0) return null;

        return {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / (1000 * 60)) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        };
      }
    };

    const timer = setInterval(() => {
      const updated = calculateTimeLeft();
      if (!updated) clearInterval(timer);
      setTimeLeft(updated);
      setLoading(false);
    }, 1000);

    return () => clearInterval(timer);
  }, [us30]);

  function getYoutubeThumbnail(url) {
    const regex = /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?/]+)/;
    const match = url.match(regex);
    if (match && match[1]) {
      return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    }
    return null;
  }

  const handleJoinSession = () => {
    if (timeLeft) {
      // Session hasn't started yet
      setShowPopup(true);
    } else {
      // Session has started
      setIsZoomMeetingScreen();
      setSelectedZoomSession(us30);
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.appBar}>
        <h2 className={styles.title}>US30</h2>
      </div>

      <div className={styles.scrollableContent}>
        <img src={us30BannerImage} className={styles.bannerImage} alt="us30" />
        <div className={styles.container}>
          <div className={styles.textSection}>
            <h2 className={styles.subtitle}>
              Meet The Alpha Universe Project Founder
            </h2>
            <h4 className={styles.description}>
              With more than 16 years of experience, Abdallah Harfouch is a
              specialist in financial and investment orientation, a financial
              market analyst, and an economist.
              <br />
              <br />
              Abdallah believes that the solution must start with providing a
              perfect Financial Education to our society in order for every
              individual to find their own financial solutions. For this matter,
              he has founded AH Financial Consultancy and Cash.
              <br />
              <br />
              In the aim of creating a healthier lifestyle for each person
              related to his financial & social life with all its aspects,
              Abdallah has founded and managed EcoLearn Summit, organized for
              the last 4 years to educate & raise awareness about the importance
              of Financial Education and Investment Opportunities in the Middle
              East and MENA region.
              <br />
              <br />
              As part of his vision for a better future and to create money
              solutions, Abdallah has founded Alpha Universe Project: a leading
              project that teaches and educates people worldwide while offering
              tools to generate more than 4 streams of income online by
              combining financial markets, social selling, and marketing.
              <br />
              <br />
              Furthermore, Abdallah, as an international speaker, has been
              hosted by a wide range of TV and Radio channels. In addition,
              Abdallah has spoken at BDL Accelerate 2016, EcoLearn Summit,
              universities, and other local and international platforms.
            </h4>
          </div>

          <div className={styles.imageSection}>
            <img
              src={founderImage}
              className={styles.introImage}
              alt="Founder"
            />
          </div>
        </div>

        {us30 && (
          <div>
            {us30.videos.length > 0 && (
              <div>
                <h2 className={styles.subtitle}>Watch videos to start</h2>
                <div className={styles.scrollContainer}>
                  <button className={styles.arrow} onClick={scrollLeft}>
                    ❮
                  </button>
                  <div className={styles.videoList} ref={scrollRef}>
                    {(us30.videos || []).map((video, index) => (
                      <img
                        key={index}
                        src={
                          getYoutubeThumbnail(video) ?? videoPlaceholderImage
                        }
                        className={styles.videoCard}
                        alt={`Video ${index + 1}`}
                        onClick={() =>
                          window.open(video, "_blank", "noopener,noreferrer")
                        }
                      />
                    ))}
                  </div>
                  <button className={styles.arrow} onClick={scrollRight}>
                    ❯
                  </button>
                </div>
              </div>
            )}

            <h2 className={styles.subtitle}>Join Live Session</h2>
            <button className={styles.submitBtn} onClick={handleJoinSession}>
              ▶
            </button>

            {timeLeft ? (
              <div className={styles.timerContainer}>
                <div className={styles.timerBlock}>
                  <div className={styles.timerValue}>{timeLeft.days}</div>
                  <div className={styles.timerLabel}>Days</div>
                </div>
                <div className={styles.timerBlock}>
                  <div className={styles.timerValue}>{timeLeft.hours}</div>
                  <div className={styles.timerLabel}>Hours</div>
                </div>
                <div className={styles.timerBlock}>
                  <div className={styles.timerValue}>{timeLeft.minutes}</div>
                  <div className={styles.timerLabel}>Minutes</div>
                </div>
                <div className={styles.timerBlock}>
                  <div className={styles.timerValue}>{timeLeft.seconds}</div>
                  <div className={styles.timerLabel}>Seconds</div>
                </div>
              </div>
            ) : (
              !loading && (
                <div className={styles.sessionUnavailable}>
                  Session started.
                </div>
              )
            )}
          </div>
        )}
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div
          className={styles.popupOverlay}
          onClick={() => setShowPopup(false)}
        >
          <div
            className={styles.popupContent}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Session Not Started Yet</h3>
            <p>
              This session hasn't started yet. Please wait for the countdown to
              finish.
            </p>
            <button
              className={styles.popupButton}
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Us30Page;
